import { settingsConstants } from "utils/constants/settings-constants";
import store from "services/redux/store";
import { dataConstants } from "services/redux/data/constants";
import HelperSetting from "utils/helper-setting";
import { setData } from "services/redux/data/actions";
import { MODES } from 'utils/constants/app-modes';
import HelperVersion from "utils/helper-version";
import _ from "lodash";
import HelperPlatform from "utils/helper-platform";

const HelperSettingNotifications = {

	validate: () => {
		let showNotifications = false;
		
		const currentMode = store.getState().data[ dataConstants.MODE ];
		const ignoreNotifications = _.get( store.getState().data, dataConstants.IGNORE_NOTIFICATIONS, false );

		switch( true ) {
			// Check if native app version is correct
			case HelperPlatform.isNotWeb() && HelperVersion.compareBuild( HelperSetting.get( settingsConstants.OTA_APP_VERSION_REQUIREMENT ) ) === false:
				showNotifications = true;
				break;
			
				// Check if native app version is correct
			case HelperPlatform.isNotWeb() && HelperVersion.compareApp( HelperSetting.get( settingsConstants.NATIVE_APP_VERSION_REQUIREMENT ) ) === false:
				showNotifications = true;
				break;
				
			// Check if maintenance mode is on
			case HelperSetting.isYes( settingsConstants.MAINTENANCE ):
				showNotifications = true;
				break;
		}
		
		let newMode = null;

		if( ignoreNotifications === false ) {
			if ( showNotifications && currentMode !== MODES.NOTIFICATIONS ) {
				newMode = MODES.NOTIFICATIONS;
			} else if ( showNotifications === false && currentMode === MODES.NOTIFICATIONS ) {
				newMode = MODES.SCHEDULE;
			}
		} else if( currentMode === MODES.NOTIFICATIONS ) {
			newMode = MODES.SCHEDULE;
		}
		
		if( newMode !== null ) {
			store.dispatch( setData( dataConstants.MODE, newMode ) );
		}
	}
}

export default HelperSettingNotifications
